import Color from 'color';
import { EditorTheme } from '@loyalty/shared-common/template-api-client';
import { buildBackgroundImageStyle } from './utils/background-image-helper';

const opacities = [10, 40, 50, 80];

export function convertThemeToCss(theme: EditorTheme) {
  const { global, button, text, progressBar } = theme;

  const backgroundImageCss = global.backgroundImage?.url
    ? `
      body {
        ${buildBackgroundImageStyle(global.backgroundImage)}
      }
    `
    : '';

  return `
      :root {
        --background-color: ${global.backgroundColor};
        --block-color: ${global.blocksColor};
        --global-radius: ${global.globalRadius}px;
        --image-radius: ${global.imageRadius}px;

        --primary: ${global.primaryColor};
        --primary-text-contrast: ${getContrastColor(global.primaryColor)};
        ${opacities
          .map(alpha => `--primary-${alpha}: ${opacifyColor(global.primaryColor, alpha / 100)};`)
          .join('\n')}

        --secondary: ${global.secondaryColor};
        --secondary-text-contrast: ${getContrastColor(global.secondaryColor)};
        ${opacities
          .map(
            alpha => `--secondary-${alpha}: ${opacifyColor(global.secondaryColor, alpha / 100)};`,
          )
          .join('\n')}

        --paragraph-family: '${text.paragraph.fontFamily}';
        --paragraph-size: ${text.paragraph.fontSize}px;
        --paragraph-weight: ${text.paragraph.fontWeight};
        --paragraph-color: ${text.paragraph.color};

        --paragraph-link-color: ${text.paragraph.linkColor};

        --title-family: '${text.title.fontFamily}';
        --title-size: ${text.title.fontSize}px;
        --title-weight: ${text.title.fontWeight};
        --title-color: ${text.title.color};

        --subtitle-family: '${text.subtitle.fontFamily}';
        --subtitle-size: ${text.subtitle.fontSize}px;
        --subtitle-weight: ${text.subtitle.fontWeight};
        --subtitle-color: ${text.subtitle.color};

        --button-family: '${button.fontFamily}';
        --button-weight: ${button.fontWeight};
        --button-size: ${button.fontSize}px;
        --button-text-color: ${button.color};
        --button-bg-color: ${button.backgroundColor};
        --button-radius: ${button.borderRadius}px;

        --progressbar-background-color: ${progressBar.backgroundColor};
        --progressbar-progress-color: ${progressBar.progressColor};
      }
      ${backgroundImageCss}
    `;
}

function getContrastColor(colorValue: string, dark = 'black', light = 'white') {
  try {
    return Color(colorValue).isDark() ? light : dark;
  } catch (e: any) {
    return light;
  }
}

function opacifyColor(colorValue: string, alpha = 1) {
  try {
    return Color(colorValue).alpha(alpha).string();
  } catch (e: any) {
    return colorValue;
  }
}
